import React from "react";
import { Redirect } from "react-router";

import type { RedirectState } from "modules/router";

export const RedirectToInternal: React.FC<{
  path: string;
  state: RedirectState;
}> = (props) => {
  return <Redirect to={{ pathname: props.path, state: props.state }} />;
};
